export interface FocusEventDTO {
    Id: string,
    Source: FocusEventSource
  }
    
  export enum FocusEventSource {
    ContactCenter,
    CRM
  }